/**
 * Created by roman.kupin on 6/19/2018.
 */



const noop = () => {};

export default noop;